import styled from "styled-components";
import ThemeColors from "../../themes/colors";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${ThemeColors.Bg2500};
  height: 100%;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  overflow: auto;
  height: 100%;
  margin-bottom: 2rem;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const SelectItemImg = styled.img`
  height: 12rem;
`;
